import React from 'react';
import { motion } from 'framer-motion';
import { Timer, LineChart, Trophy, Users } from 'lucide-react';
import { useI18n } from '../../../i18n';
import AppScreenShowcase from './AppScreenShowcase';

const STORY_ICONS = [Timer, LineChart, Trophy, Users];
const STORY_COLORS = ['#80dfaf', '#89b9f1', '#e9c480', '#b4a1ee'];

export function SectorSeam({ label, value, color, icon: Icon }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ amount: 'some', margin: '0px 0px -20% 0px' }}
      transition={{ duration: 0.5 }}
      className="absolute top-6 inset-x-0 flex items-center gap-4 pointer-events-none"
      aria-hidden
    >
      <span
        className="flex-1 h-px"
        style={{ background: 'linear-gradient(90deg, transparent, var(--glass-border))' }}
      />
      <span
        className="flex items-center gap-2.5 rounded-full px-4 py-1.5"
        style={{
          background: 'var(--glass-bg)',
          border: '1px solid var(--glass-border)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
        }}
      >
        {Icon && <Icon size={12} style={{ color }} />}
        <span className="text-[10px] font-bold uppercase tracking-[0.3em]" style={{ color: 'var(--text-muted)' }}>
          {label}
        </span>
        <span className="font-mono text-[11px] font-black" style={{ color }}>
          {value}
        </span>
      </span>
      <span
        className="flex-1 h-px"
        style={{ background: 'linear-gradient(270deg, transparent, var(--glass-border))' }}
      />
    </motion.div>
  );
}


// The content is ordinary document flow in both background modes. Switching the
// 3D scene cannot leave a headline in a previous entrance animation's hidden state.
export default function StorySection({ index, align }) {
  const { t } = useI18n();
  const Icon = STORY_ICONS[index];
  const prefix = 'loginShowcase.sections.' + index;
  return (
    <section className={`login-story login-story--screens hidden lg:flex min-h-screen items-center relative ${align === 'right' ? 'justify-end' : 'justify-start'}`} aria-labelledby={`login-story-title-${index}`}>
      <AppScreenShowcase index={index}/>
      <article className="login-story-copy" style={{ '--story-accent': STORY_COLORS[index] }}>
        <div className="login-story-kicker"><Icon size={16} aria-hidden="true"/><span>{String(index + 1).padStart(2, '0')} / 04</span><span>{t(prefix + '.label')}</span></div>
        <h2 id={`login-story-title-${index}`}><span>{t(prefix + '.first')}</span><span>{t(prefix + '.second')}</span></h2>
        <p>{t(prefix + '.body')}</p>
      </article>
    </section>
  );
}
